export const AppRoutes = {
  home: "/",
  overview: "/overview",
  login: "/login",
  dashboard: "/dashboard",
  verifyEmail: "/verify-email",
};
